import { render, staticRenderFns } from "./responsable-sg-registrar.vue?vue&type=template&id=31386ba1&scoped=true&"
import script from "./responsable-sg-registrar.vue?vue&type=script&lang=js&"
export * from "./responsable-sg-registrar.vue?vue&type=script&lang=js&"
import style0 from "./responsable-sg-registrar.vue?vue&type=style&index=0&id=31386ba1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31386ba1",
  null
  
)

export default component.exports